import styled from 'styled-components';
import { Text } from '../index';

export const BoxStyled = styled.div`
  padding: 32px;
`;

export const TitleStyles = styled(Text)`
  font-family: FS Emeric;
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  `;

export const DescriptionStyles = styled(Text)`
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  margin-top: 16px;
`;